// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TVGraphic {
    height: 100vh;
    width: 100vw;
    margin: 0;
    overflow: hidden;
}

.TVGraphic .sidebar .txtCenter p {
    color: var(--dark);
}

.TVGraphic .weather {
    position: absolute;
    z-index: 100;
    top: 24px;
    right: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 4px 32px;
    border-radius: 8px;
    box-shadow: 1px 1px 16px 1px rgba(20, 50, 12, 0.25);
    background-color:  rgba(255, 255, 255, 0.88);
    backdrop-filter: blur(4px);
}

.TVGraphic .weather p {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
}

.TVGraphic .weatherIcon {
    height: 60px;
    filter: drop-shadow(0px 0px 4px rgba(0,0,0,0.5));
}

.TVGraphic .timeWeather i {
    margin: 0 8px;
}

.TVGraphic .donors p {
    padding: 8px 16px;
    border-radius: 6px;
    box-shadow: var(--box-shadow);
    background-color: var(--white);
    width: fit-content;
    margin: 0;
}

.TVGraphic .sidebar {
    width: 340px;
    height: 900px;
    position: absolute;
    left: 24px;
    top: 24px;
    border-radius: 8px;
    box-shadow: 1px 1px 16px 1px rgba(20, 50, 12, 0.25);
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color:  rgba(255, 255, 255, 0.88);
    backdrop-filter: blur(4px);
    align-items: center;
    padding: 2em;
}

.TVGraphic .qrPrompt img {
    width: 65px;
}

.TVGraphic .qrPrompt p {
    margin: 0;
}

.TVGraphic .bottomBanner {
    background-color: var(--light);
    padding: 2em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
}

.TVGraphic .bottomBanner .time {
    text-align: center;
}

.TVGraphic .bottomBanner .ctaHeader {
    font-weight: 600;
    font-size: 1.3em;
}

.TVGraphic .bottomBanner h2 {
    font-size: 2em;
    margin-top: 0;
    margin-bottom: 0;
}

.TVGraphic .bottomBanner p {
    font-size: 1em;
    margin-top: 0;
    margin-bottom: 2px;
}

.TVGraphic .cta {
    margin-right: 16px;
    text-align: end;
}

.TVGraphic .qrPrompt {
    display: flex;
    justify-content: center;
}

.TVGraphic .Donor.patron {
    padding: 0 8px;
}

.TVGraphic .Donor.patron p {
    padding: 0px;
    margin: 4px 0px;
    font-size: 0.9em;
}

.TVGraphic .Donor.benefactor p {
    padding: 0px;
    margin: 10px 8px;
    font-size: 0.9em;
}

.TVGraphic .Donor.benefactor {
    padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/TVGraphic.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,mDAAmD;IACnD,4CAA4C;IAE5C,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,gDAAgD;AACpD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,mDAAmD;IACnD,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,4CAA4C;IAC5C,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd","sourcesContent":[".TVGraphic {\n    height: 100vh;\n    width: 100vw;\n    margin: 0;\n    overflow: hidden;\n}\n\n.TVGraphic .sidebar .txtCenter p {\n    color: var(--dark);\n}\n\n.TVGraphic .weather {\n    position: absolute;\n    z-index: 100;\n    top: 24px;\n    right: 24px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 4px 32px;\n    border-radius: 8px;\n    box-shadow: 1px 1px 16px 1px rgba(20, 50, 12, 0.25);\n    background-color:  rgba(255, 255, 255, 0.88);\n    -webkit-backdrop-filter: blur(4px);\n    backdrop-filter: blur(4px);\n}\n\n.TVGraphic .weather p {\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.TVGraphic .weatherIcon {\n    height: 60px;\n    filter: drop-shadow(0px 0px 4px rgba(0,0,0,0.5));\n}\n\n.TVGraphic .timeWeather i {\n    margin: 0 8px;\n}\n\n.TVGraphic .donors p {\n    padding: 8px 16px;\n    border-radius: 6px;\n    box-shadow: var(--box-shadow);\n    background-color: var(--white);\n    width: fit-content;\n    margin: 0;\n}\n\n.TVGraphic .sidebar {\n    width: 340px;\n    height: 900px;\n    position: absolute;\n    left: 24px;\n    top: 24px;\n    border-radius: 8px;\n    box-shadow: 1px 1px 16px 1px rgba(20, 50, 12, 0.25);\n    background-color: var(--white);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-color:  rgba(255, 255, 255, 0.88);\n    backdrop-filter: blur(4px);\n    align-items: center;\n    padding: 2em;\n}\n\n.TVGraphic .qrPrompt img {\n    width: 65px;\n}\n\n.TVGraphic .qrPrompt p {\n    margin: 0;\n}\n\n.TVGraphic .bottomBanner {\n    background-color: var(--light);\n    padding: 2em;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n}\n\n.TVGraphic .bottomBanner .time {\n    text-align: center;\n}\n\n.TVGraphic .bottomBanner .ctaHeader {\n    font-weight: 600;\n    font-size: 1.3em;\n}\n\n.TVGraphic .bottomBanner h2 {\n    font-size: 2em;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.TVGraphic .bottomBanner p {\n    font-size: 1em;\n    margin-top: 0;\n    margin-bottom: 2px;\n}\n\n.TVGraphic .cta {\n    margin-right: 16px;\n    text-align: end;\n}\n\n.TVGraphic .qrPrompt {\n    display: flex;\n    justify-content: center;\n}\n\n.TVGraphic .Donor.patron {\n    padding: 0 8px;\n}\n\n.TVGraphic .Donor.patron p {\n    padding: 0px;\n    margin: 4px 0px;\n    font-size: 0.9em;\n}\n\n.TVGraphic .Donor.benefactor p {\n    padding: 0px;\n    margin: 10px 8px;\n    font-size: 0.9em;\n}\n\n.TVGraphic .Donor.benefactor {\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
